import React, { ComponentProps } from 'react';

import { BaseButton } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

export const SubmitButton = (props: Omit<BaseProps, 'htmlType'>) => (
  <BaseButton type="primary" htmlType="submit" {...props}>
    {props.children}
  </BaseButton>
);
